import { Icon, type TIconProps } from '~/components/icon'
import type { TRadioSizes } from '../../types'
import * as Comp from './helper-text.styles'

type IHelperTextProps = {
  children: string
  size?: TRadioSizes
  testID?: string
}

export function RadioHelperText({
  size = 'md',
  testID,
  ...props
}: IHelperTextProps) {
  const iconSizeMapping: Record<TRadioSizes, TIconProps['size']> = {
    md: 'tiny',
    ml: 'tiny',
    lg: 'tiny',
    xl: 'tiny',
  }

  return (
    <Comp.Root testID={testID} size={size}>
      <Icon
        size={iconSizeMapping[size]}
        symbol="rdicon-warning-circle"
        color="colorTextDangerAlternative"
      />

      <Comp.Label numberOfLines={2}>{props.children}</Comp.Label>
    </Comp.Root>
  )
}
